import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AdsCounter.styles';
import { useAdsCounter } from './AdsCounter.hooks';
import { useServerDataContext } from '@/contexts';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { PropertyOptions } from '@/hooks/useParseQuery/useParseQuery.types';
import { formatNumber, setSuffix } from '@/utils/helpers';

export const AdsCounter = ({
  propertyOptions,
}: {
  propertyOptions?: PropertyOptions | null;
}) => {
  const { currentCategory: serverCurrentCategory } = useServerDataContext();
  const { currentCategory = serverCurrentCategory } = useCurrentCategory();
  const { adsAmount, loading } = useAdsCounter(
    currentCategory,
    undefined,
    propertyOptions
  );
  const { t, i18n } = useTranslation();

  const hasAdsAmount = adsAmount !== undefined && adsAmount !== null;

  if (!hasAdsAmount && !loading) {
    return null;
  }

  return (
    <S.AdsCounterContainer>
      {loading ? (
        <S.AdsCounterSkeletonLoader />
      ) : (
        hasAdsAmount &&
        t(setSuffix(i18n, String(adsAmount), 'common.n_ads'), {
          n: formatNumber(adsAmount, 0),
        })
      )}
    </S.AdsCounterContainer>
  );
};
